let cleanupServicesHighlight = null;

/** Item counts as “passed” when its top crosses this fraction of viewport height (higher = highlight sooner). */
const ACTIVE_TRIGGER_VH = 0.60;

/**
 * IntersectionObserver root shrink — smaller top/bottom insets = wider middle band = updates earlier while scrolling.
 * Format: top right bottom left (CSS-style).
 */
const OBSERVER_ROOT_MARGIN = "-35% 0px -35% 0px";

export function initServicesHighlight() {
  if (typeof cleanupServicesHighlight === "function") {
    cleanupServicesHighlight();
    cleanupServicesHighlight = null;
  }

  const list = document.querySelector(".c-services-list");
  if (!(list instanceof HTMLElement)) return;

  const items = Array.from(list.querySelectorAll(".c-services-list__item")).filter(
    (item) => item instanceof HTMLElement
  );
  if (!items.length) return;

  let activeIndex = -1;

  const setActive = (index) => {
    if (index === activeIndex) return;
    items.forEach((item, itemIndex) => {
      item.classList.toggle("is-active", itemIndex <= index);
    });
    activeIndex = index;
  };

  const pickActiveFromScroll = () => {
    const triggerY = window.innerHeight * ACTIVE_TRIGGER_VH;
    let nextActive = -1;

    items.forEach((item, index) => {
      if (item.getBoundingClientRect().top <= triggerY) {
        nextActive = index;
      }
    });

    if (nextActive === -1) {
      const listRect = list.getBoundingClientRect();
      const listIsVisible = listRect.top < window.innerHeight && listRect.bottom > 0;
      if (listIsVisible) nextActive = 0;
    }

    setActive(nextActive);
  };

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .map((entry) => entry.target)
          .filter((target) => target instanceof HTMLElement);

        if (!visible.length) return;

        visible.sort(
          (a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top
        );

        const current = visible[visible.length - 1];
        const index = items.indexOf(current);
        if (index !== -1) setActive(index);
      },
      {
        root: null,
        rootMargin: OBSERVER_ROOT_MARGIN,
        threshold: 0,
      }
    );

    items.forEach((item) => observer.observe(item));
    pickActiveFromScroll();

    const onResize = () => pickActiveFromScroll();
    window.addEventListener("resize", onResize);

    cleanupServicesHighlight = () => {
      observer.disconnect();
      window.removeEventListener("resize", onResize);
    };
    return;
  }

  let ticking = false;
  let rafId = null;
  const requestApply = () => {
    if (ticking) return;
    ticking = true;
    rafId = window.requestAnimationFrame(() => {
      ticking = false;
      pickActiveFromScroll();
    });
  };

  requestApply();
  window.addEventListener("scroll", requestApply, { passive: true });
  window.addEventListener("resize", requestApply);

  cleanupServicesHighlight = () => {
    if (rafId) window.cancelAnimationFrame(rafId);
    window.removeEventListener("scroll", requestApply);
    window.removeEventListener("resize", requestApply);
  };
}
